"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _ScreenReaderText = _interopRequireDefault(require("../ScreenReaderText"));

var _SpinnerAnimation = _interopRequireDefault(require("./Assets/SpinnerAnimation"));

var _useDirection3 = _interopRequireDefault(require("../hooks/useDirection"));

var _useForceRender = _interopRequireDefault(require("../hooks/internal/useForceRender"));

var _useLocalizer = _interopRequireDefault(require("../hooks/useLocalizer"));

var _useStyleOptions3 = _interopRequireDefault(require("../hooks/useStyleOptions"));

var _useStyleSet3 = _interopRequireDefault(require("../hooks/useStyleSet"));

var _useTimer = _interopRequireDefault(require("../hooks/internal/useTimer"));

var _WarningNotificationIcon = _interopRequireDefault(require("./Assets/WarningNotificationIcon"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ConnectivityStatusConnecting = function ConnectivityStatusConnecting(_ref) {
  var reconnect = _ref.reconnect;

  var _useStyleOptions = (0, _useStyleOptions3.default)(),
      _useStyleOptions2 = _slicedToArray(_useStyleOptions, 1),
      slowConnectionAfter = _useStyleOptions2[0].slowConnectionAfter;

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      _useStyleSet2$ = _useStyleSet2[0],
      connectivityNotificationStyleSet = _useStyleSet2$.connectivityNotification,
      warningNotificationStyleSet = _useStyleSet2$.warningNotification;

  var _useDirection = (0, _useDirection3.default)(),
      _useDirection2 = _slicedToArray(_useDirection, 1),
      direction = _useDirection2[0];

  var _useState = (0, _react.useState)(function () {
    return Date.now();
  }),
      _useState2 = _slicedToArray(_useState, 1),
      initialRenderAt = _useState2[0];

  var forceRender = (0, _useForceRender.default)();
  var localize = (0, _useLocalizer.default)();
  var initialConnectionText = localize('CONNECTIVITY_STATUS_ALT_CONNECTING');
  var interruptedConnectionText = localize('CONNECTIVITY_STATUS_ALT_RECONNECTING');
  var slowConnectionText = localize('CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION');
  (0, _useTimer.default)(initialRenderAt + slowConnectionAfter, forceRender);
  var now = Date.now();
  var slow = now >= initialRenderAt + slowConnectionAfter;
  return slow ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ScreenReaderText.default, {
    text: localize('CONNECTIVITY_STATUS_ALT', slowConnectionText)
  }), _react.default.createElement("div", {
    "aria-hidden": true,
    className: (0, _classnames.default)('webchat__connectivityStatus', warningNotificationStyleSet + ''),
    dir: direction
  }, _react.default.createElement(_WarningNotificationIcon.default, null), slowConnectionText)) : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ScreenReaderText.default, {
    text: localize('CONNECTIVITY_STATUS_ALT', reconnect ? interruptedConnectionText : initialConnectionText)
  }), _react.default.createElement("div", {
    "aria-hidden": true,
    className: (0, _classnames.default)('webchat__connectivityStatus', connectivityNotificationStyleSet + ''),
    dir: direction
  }, _react.default.createElement(_SpinnerAnimation.default, null), reconnect ? interruptedConnectionText : initialConnectionText));
};

ConnectivityStatusConnecting.defaultProps = {
  reconnect: false
};
ConnectivityStatusConnecting.propTypes = {
  reconnect: _propTypes.default.bool
};
var _default = ConnectivityStatusConnecting;
exports.default = _default;